'use strict';
declare module 'react-native-web/dist/exports/StyleSheet/compiler/createReactDOMStyle';
declare module 'react-native-web/dist/exports/StyleSheet/preprocess';
